import { ObservableArray, View } from "binder"
import { customerForSelector, SearchCustomerViewModel } from "./searchCustomer-viewModel"

export class SearchCustomerView extends View<SearchCustomerViewModel>{
    GetViewUniqueId(): string {
        return "V-F412F27C-628E-4016-955A-AB6C2D99B455"
    }
    loadHtml(): string {
        let element = require('./searchCustomer.html').default;
        let style = require('./searchCustomer.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set items(v: ObservableArray<customerForSelector>) { this._items = v; } public get items(): ObservableArray<customerForSelector> { return this._items;} private _items: ObservableArray<customerForSelector>;
    public set selectedItem(v: customerForSelector) { this._selectedItem = v; } public get selectedItem(): customerForSelector { return this._selectedItem;} private _selectedItem: customerForSelector;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set searchedText(v: string) { this._searchedText = v; } public get searchedText(): string { return this._searchedText;} private _searchedText: string;
    public set isShowingPopup(v: boolean) { 
        this._isShowingPopup = v;
        if(v && this.popup_container)
            this.preferredWidth = this.popup_container.clientWidth.toString()+"px";
    } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set preferredWidth(v: string) { this._preferredWidth = v; } public get preferredWidth(): string { return this._preferredWidth;} private _preferredWidth: string;
    public set popup_container(v: HTMLElement) { this._popup_content = v; } public get popup_container(): HTMLElement { return this._popup_content;} private _popup_content: HTMLElement;
    
    
    onkeydown(e:KeyboardEvent){
        if(e.key=="Enter"){
            this.refresh();
        }
    }
    public onRenderCompleted() {
        this.popup_container = this.firstlevelElement.querySelector("#V-41490DFA-051F-45BA-88F0-AFD2585640E0-popup-container");
        this.preferredWidth = this.popup_container.clientWidth.toString()+"px";
    }
    refresh(){
        this.dataContext.runLast();
    }

}
